import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import {
    type ICompanyRegistrationProfileInfoClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyRegistrationProfileInfoClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class SupporterCompanyRegistrationProfileInfoQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ICompanyRegistrationProfileInfoClient')
        public readonly companyRegistrationProfileInfoClient: ICompanyRegistrationProfileInfoClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyRegistrationProfileInfoClient.get({});
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
